module.exports = __webpack_public_path__ + "img/feed_check.18a8a9d9.svg";